import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  Badge,
} from "reactstrap";
import { useLocation } from "react-router-dom";

import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingData from "../../TESTPage/LoadingData";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { ConvertDate } from "../../Function/ConvertDate";
import { useLayOutConText } from "../../Context/LayOutContext";
import ModalApproveData from "../ModalApproveData";
import ModalConfirmApprove from "./ModalConfirmApprove";
import { Tooltip } from "@mui/material";
import { ChunkArray } from "../../Function/ChunkArray";
import ModalNotApprove from "../ModalNotApprove";
import { CheckBudgetYear } from "../../Function/CheckBudgetYear";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";
import { checkFinalApprove } from "../../Function/CheckFinalApprove";
import { leaveStatusBadge } from "../../Function/LeaveStatusBadge";
import { FetchAxiosGet } from "../../../api/axios";
import SelectOrg from "../../EntryWork/selectOrg/selectOrg";

const TableApprove = ({
  isFromIndex = false,
  selectRow = 10,
  budgetYear = null,
  // layoutModeType,
  // changeLayoutMode,
}) => {
  const { setNumApprove } = useLayOutConText();
  document.title = "การลาออนไลน์ | Flexible-Time";
  const baseURL = process.env.REACT_APP_API_CORS;
  // const userApproveForPSED = Number(process.env.REACT_APP_USER_APPROVE_FOR_PSED);
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;

  
  const [userInfo, setUserInfo] = useState([]);  
  const user_position = user_id === userInfo?.psac_user_approve?.approve_user_id ? 8 :
    userPosition &&
    userPosition
      .sort((a, b) => a?.position_id - b?.position_id)
      ?.find((a) =>
        a?.position_id === 2
          ? 2
          : a?.position_id === 3
            ? 3
            : a?.position_id === 4
              ? 4
              : a?.position_id === 5
                ? 5
                : a?.position_id === 6
                  ? 6
                  : a?.position_id === 7
                    ? 7
                    : null
      )?.position_id;
  // const position = user_position.
  const location = useLocation();
  const paramValue =
    new URLSearchParams(location?.search).get("exitbefore") || "";

  const [isloading, setIsLoading] = useState(true);
  const [budgetYearSelectList, setBudgetYearSelectList] = useState([]);
  const [filTerStatus, setFilTerStatus] = useState(null)
  const [divisionOrg, setDivisionOrg] = useState(null);
  const [groupOrg, setGroupOrg] = useState(null);
  const [userOrg, setUserOrg] = useState(null);
  const [arrayOrgGroup, setArrayOrgGroup] = useState(null)
  const [currentBudgetYear, setCurrentBudgetYear] = useState(budgetYear ?? CheckBudgetYear());
  const [leaveData, setLeaveData] = useState([]);
  const [dataApprove, setDataApprove] = useState([]);
  const [leaveDataEditApprove, setLeaveDataEditApprove] = useState();
  const [chunkDataApprove, setChunkDataApprove] = useState([]);
  const [typeLeaveName, setTypeLeaveName] = useState([]);
  const [configForm, setConfigForm] = useState([]);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [modalEditApprove, setModalEditApprove] = useState(false);
  const [getUserApprove, setGetUserApprove] = useState([]);
  const [getFlowApprove, setGetFlowApprove] = useState([]);
  const [checkPosition, setCheckPosition] = useState([]);
  const [leaveDataEdit, setLeaveDataEdit] = useState();
  const [searchData, setSearchData] = useState({
    docApproveType: "",
    leave_type_id: "",
    fromDate: "",
    toDate: "",
    status: "",
    budgetYear: null,
  });
  const [approvePagination, setApprovePagination] = useState({
    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [sortCount, setSortCount] = useState({
    id: 0,
    typeId: 0,
    fromDate: 0,
    toDate: 0,
  });
  const [modalNotApprove, setModalNotApprove] = useState({
    modal: false,
    name: "",
    itemUpdate: {},
    leaveApproveId: null,
    leaveApproveStatus: null,
    leaveDataId: null,
    leaveDataStatus: null,
  });

  //////////////// นำตาราง leave_data มาเทียบ
  const getLeaveDataTable = async (budget_year = searchData?.budgetYear ?? currentBudgetYear) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 100000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        // "filter[user_id][0]": user_id,
        "filter[budget_year][0]": budget_year,
        "filter[leave_status][0]": 3,
        "filter[leave_status][1]": 4,
        "filter[leave_status][2]": 5,
        "filter[leave_status][3]": 6,
        "filter[leave_status][4]": 8,
        "filter[leave_status][5]": 9,
        "filter[leave_status][6]": "A",
        "filter[leave_status][7]": 7,
        "filter[leave_status][8]": "B",
        "filter[leave_status][9]": "C",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getFirstBudgetYearForSearch = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1,
        "order[0]": "budget_year",
        "order[1]": "ASC",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      if (res?.data?.result[0]?.budget_year) {
        let firstYear = Number(res?.data?.result[0]?.budget_year);
        let lastYear = Number(CheckBudgetYear());
        let arrYear = [];
        for (let i = firstYear; i <= lastYear; i++) {
          arrYear.push(i);
        }
        arrYear?.sort((a, b) => b - a);
        return setBudgetYearSelectList(arrYear);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res?.data?.result);
      } catch (err) {
        console.error(err);
      }
    };

    getUserInfo();
    // setTimeout(() => {
    setIsLoading(false);
    // }, 2000);
    getFirstBudgetYearForSearch();
  }, []);

  // ดึงข้อมูลใหม่เมื่อเปลี่ยนปีงบประมาณจากหน้าหลัก (เปลี่ยน leaveData แล้วจะดึง approve data ต่อเอง)
  useEffect(() => {
    const year = budgetYear ?? CheckBudgetYear();
    setCurrentBudgetYear(year);
    getLeaveDataTable(year);
  }, [budgetYear]);

  useEffect(() => {
    getApproveDataTable();
  }, [leaveData]);

  const [showApproveButton, setShowApproveButton] = useState(true)

  const getApproveDataTable = async (
    page = 1,
    approveStatus = "0",
    approveFinal = "0",
    budget_year = currentBudgetYear
  ) => {
    setIsLoading(true)
    if ((approveStatus && approveStatus != "0") || (approveStatus == "0" && approveFinal == "1")) {
      setShowApproveButton(false)
    } else {
      setShowApproveButton(true)
    }
    setChunkDataApprove([]);
    try {
      const url = baseURL + `/api/leave/approve/datatable`;
      let params = {
        page: page,
        size: 10000,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[approve_id][0]": user_id,
        "filter[approve_status][0]": isFromIndex ? "0" : approveStatus,
        // "filter[approve_status][1]": "2",
        "filter[approve_final][0]": isFromIndex ? "0" : approveFinal,
        "filter[budget_year][1]": budget_year,
      }
      approveStatus === null && delete params["filter[approve_status][0]"]
      approveFinal === null && delete params["filter[approve_final][0]"]
      searchData?.fromDate && (params["filter[leave_dmy_start][0]"] = ConvertDate(searchData?.fromDate)?.toDateISO())
      searchData?.toDate && (params["filter[leave_dmy_end][0]"] = ConvertDate(searchData?.toDate)?.toDateISO())
      searchData?.leave_type_id && (params["filter[leave_type_id][0]"] = searchData?.leave_type_id)
      userOrg && (params["filter[user_id][0]"] = userOrg)
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params
      };
      const res = await axios.get(url, config);
      setDataApprove([]);
      res?.data?.result &&
        res?.data?.result?.map((item) => {
          let leaveNameFromLeaveData = leaveData?.find(
            (a) =>
              parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
              a?.leave_status !== "8"
          )?.leave_name;
          let checkAppLeaveIdNStatus = leaveData?.find(
            (a) =>
              parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
              a?.leave_status !== "8"
          )?.leave_status;
          let newOBJ = {
            ...item,
            leave_name: leaveNameFromLeaveData,
            leave_status: checkAppLeaveIdNStatus,
          };
          if (
            leaveData?.some(
              (a) =>
                parseInt(a?.leave_data_id) === parseInt(item?.leave_data_id) &&
                a?.leave_status !== "8"
            )
          ) {
            setDataApprove((prev) => [...prev, newOBJ]);
          }
        });
      setIsLoading(false)
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setChunkDataApprove(ChunkArray(dataApprove, isFromIndex ? 5 : 10));
  }, [dataApprove]);

  //////////////// รับ Config ของทุก Form การลา
  const getConfigAll = async () => {
    try {
      const res = await axios.get(baseURL + "/api/leave/config/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setConfigForm(res?.data?.form_leave[leaveDataEdit?.form_type - 1]);
      setTypeLeaveName(res?.data?.form_leave);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getConfigAll();
  }, []);

  useEffect(() => {
    setApprovePagination((prev) => ({
      ...prev,
      totalPage: chunkDataApprove?.length,
      totalRows: dataApprove?.length,
    }));
    if (chunkDataApprove?.length > 0) setNumApprove(dataApprove?.length);
  }, [chunkDataApprove]);

  const [isSending, setIsSending] = useState(false)

  ////////// ตรวจสอบค่าของ form_type และตำแหน่งคนอนุมัติ
  let fillterLeaveStatus = null
  let lastApproveForModal = null
  const checkLeaveTypeIdAndPosition = (
    positionId,
    leave_approve_id,
    leave_data_id,
    leave_status,
    itemApprove,
    leaveDataEdit,
    isFullButton = false,
    closeModal = false,
    clickFromTable = false,
  ) => {
    let isFinal = null;
    let nextIsFinal = null;
    let sendToApprove = null;

    if (!positionId) return { component: null, isFinal: null, nextIsFinal: null, sendToApprove: null };

    let lastUserApproveIndex = itemApprove?.thisLeaveConfigFlow?.findIndex((x) => x?.last_approve === 1)
    let thisUserApproveIndex = itemApprove?.thisLeaveConfigFlow?.findIndex((x) => x?.users_position_id === user_position)

    let thisUserSeqIndex = null
    let nextUserSeq = null
    let nextUserSeqMain = null

    if (itemApprove?.approve_sequence) {
      thisUserSeqIndex = itemApprove?.approve_sequence?.findIndex((x) => x?.position_id === user_position)
      nextUserSeq = thisUserSeqIndex < 1 ? itemApprove?.approve_sequence[thisUserSeqIndex] : itemApprove?.approve_sequence[thisUserSeqIndex - 1]
      nextUserSeqMain = nextUserSeq
    }

    if (nextUserSeq?.assign === 1 && nextUserSeq?.position_main.length > 0) {
      nextUserSeqMain = nextUserSeq?.position_main[0]
    }

    console.log(itemApprove?.leave_data_id, itemApprove?.approve_sequence, itemApprove?.thisLeaveConfigFlow);


    let leaderInfo = userInfo?.leader
    let thisSendToData = `${userInfo.user_name}${userInfo.user_position_name === '-' ? '' : '-' + userInfo.user_position_name}`

    if (lastUserApproveIndex !== -1 && thisUserApproveIndex !== -1) {

      if (lastUserApproveIndex === thisUserApproveIndex) {
        isFinal = true;
      } else if (lastUserApproveIndex === (thisUserApproveIndex + 1)) {
        nextIsFinal = true;
      }
      let nextSendToData = (nextUserSeq?.assign === 1 && nextUserSeq?.position_main.length > 0) ? `${nextUserSeqMain?.user_name}-${nextUserSeqMain?.position_name}` :
        `${leaderInfo ? (leaderInfo.assign === 1 ? leaderInfo?.assigned_by_user?.user_name : leaderInfo?.user_name) : ""}-${(leaderInfo?.user_position_name_dis + leaderInfo?.org_name)}`

      if (itemApprove) {
        if (isFinal || nextIsFinal) {
          sendToApprove = isFinal ? thisSendToData : nextIsFinal ? nextSendToData : ''
          itemApprove.send_to = sendToApprove // ส่งไปแก้ db
        } else {
          sendToApprove = nextSendToData ?? ''
          itemApprove.send_to = sendToApprove // ส่งไปแก้ db
        }
      }
    } else {
      isFinal = true
      sendToApprove = thisSendToData
      itemApprove.send_to = sendToApprove
    }

    // const getPreviosDateCancel = (id) => {
    //   try {
    //     const url = baseURL + "/api/leave/cancel/list/datatable";
    //     const params = new URLSearchParams({
    //       page: 1,
    //       size: 10000,
    //       "order[0]": "date_cancel",
    //       "order[1]": "ASC",
    //       "filter[leave_data_id][0]": id,
    //       "filter[cancel_date_status][0]": 1,
    //     });
    //     const config = {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //       params,
    //     };
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };

    const dropDownJSX = (
      isFinal,
      leave_approve_id,
      leave_data_id,
      item,
      clickFromTable
    ) => {
      if (!isFinal) {
        return (
          <>
            {
              leave_status === "7" || leave_status === "B" ? (
                <>
                  <Tooltip title="อนุญาตยกเลิก">
                    <button
                      className={`ms-1 btn btn-success ${isFullButton && "w-50"}`}
                      disabled={(isSending)}
                      onClick={async () => {
                        setIsSending(true)
                        if (closeModal) {
                          setModalEditApprove(false);
                        }
                        await sendLeaveDataStatus(item, "B");
                        await sendApproveDataStatus(
                          leave_approve_id,
                          leave_data_id,
                          "1"
                        );

                        await loadingApproveTable();
                        await getApproveDataTable(1);
                        await handleOpenSubmitSuccess();
                        setIsSending(false)
                      }}
                    >
                      {isFullButton && "อนุญาตยกเลิก "}
                      <i className="fa-solid fa-check"></i>
                    </button>
                  </Tooltip>
                  <Tooltip title="ไม่อนุญาตยกเลิก">
                    <button
                      className={`ms-1 btn btn-danger ${isFullButton && "w-50"}`}
                      disabled={(isSending)}
                      onClick={async () => {
                        if (clickFromTable) {
                          OpenDataByLeaveId(leave_data_id, true);
                        }
                        if (closeModal) {
                          setModalEditApprove(false);
                        }
                        setModalNotApprove((prev) => ({
                          ...prev,
                          modal: true,
                          name: "ไม่อนุญาตยกเลิก",
                          leaveApproveId: leave_approve_id,
                          leaveApproveStatus: "0",
                          leaveDataId: leave_data_id,
                          leaveDataStatus: "5",
                          itemUpdate: item,
                        }));
                      }}
                    >
                      {isFullButton && "ไม่อนุญาตยกเลิก "}
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip title="อนุญาต">
                    <button
                      className={`ms-1 btn btn-success ${isFullButton && "w-50"}`}
                      disabled={(isSending)}
                      onClick={async () => {
                        setIsSending(true)
                        if (closeModal) {
                          setModalEditApprove(false);
                        }
                        await sendLeaveDataStatus(item, "3");
                        await sendApproveDataStatus(
                          leave_approve_id,
                          leave_data_id,
                          "1"
                        );
                        await loadingApproveTable();
                        await getApproveDataTable(1);
                        await handleOpenSubmitSuccess();
                        setIsSending(false)
                      }}
                    >
                      {isFullButton && "อนุญาต "}
                      <i className="fa-solid fa-check"></i>
                      {/* {isSending ? ((<i className="bx bx-loader bx-spin font-size-16 align-middle"></i>)):(<i className="fa-solid fa-check"></i>)} */}
                    </button>
                  </Tooltip>
                  <Tooltip title="ไม่อนุญาต">
                    <button
                      className={`ms-1 btn btn-danger ${isFullButton && "w-50"}`}
                      disabled={(isSending)}
                      onClick={async () => {
                        if (closeModal) {
                          setModalEditApprove(false);
                        }
                        setModalNotApprove((prev) => ({
                          ...prev,
                          modal: true,
                          name: "ไม่อนุญาต",
                          leaveApproveId: leave_approve_id,
                          leaveApproveStatus: "0",
                          leaveDataId: leave_data_id,
                          leaveDataStatus: "6",
                          itemUpdate: item,
                        }));
                      }}
                    >
                      {isFullButton && "ไม่อนุญาต "}
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </Tooltip>
                </>
              )
            }
          </>
        );
      } else {
        return (
          <>
            {leave_status === "7" ||
              leave_status === "B" ||
              leave_status === "5" ? (
              <>
                <Tooltip title="อนุมัติยกเลิก">
                  <button
                    className={`ms-1 btn btn-success ${isFullButton && "w-50"}`}
                    disabled={(isSending)}
                    onClick={async () => {
                      // await sendLeaveDataStatus(item, "A");
                      setIsSending(true)
                      if (closeModal) {
                        setModalEditApprove(false);
                      }
                      let haveCancelDateStatus2 = false;
                      let sufWord = " (อนุมัติยกเลิกเสร็จสิ้น)";
                      if (clickFromTable) {
                        const FinalApprove = async () => {
                          const getDateCancel = async (id) => {
                            try {
                              const url =
                                baseURL + "/api/leave/cancel/list/datatable";
                              const params = new URLSearchParams({
                                page: 1,
                                size: 10000,
                                "order[0]": "date_cancel",
                                "order[1]": "ASC",
                                "filter[leave_data_id][0]": id,
                              });
                              const config = {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                },
                                params,
                              };
                              const res = await axios.get(url, config);
                              return res?.data?.result?.sort(
                                (a, b) =>
                                  new Date(a?.date_cancel) -
                                  new Date(b?.date_cancel)
                              );
                            } catch (err) {
                              console.error(err);
                            }
                          };
                          const deleteDateCancelBeforeApprove = async (
                            arrDateCancel
                          ) => {
                            try {
                              (await arrDateCancel) &&
                                (await arrDateCancel?.map(async (item, idx) => {
                                  if (item?.cancel_date_status === 1) {
                                    const res = await axios.delete(
                                      baseURL +
                                      `/api/leave/cancel/list/${item?.id_leave_date_list}`,
                                      {
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                        },
                                      }
                                    );
                                  }
                                }));
                            } catch (err) {
                              console.error(err);
                            }
                          };
                          const editDateCancel = async (arrDateCancel) => {
                            try {
                              (await arrDateCancel) &&
                                (await arrDateCancel?.map(async (item, idx) => {
                                  if (item?.cancel_date_status === 2) {
                                    sufWord = " (อนุมัติยกเลิกบางวันเสร็จสิ้น)"
                                    haveCancelDateStatus2 = true;
                                    const res = await axios.put(
                                      baseURL +
                                      `/api/leave/cancel/list/${item?.id_leave_date_list}`,
                                      {
                                        leave_data_id: item?.leave_data_id,
                                        date_cancel: item?.date_cancel,
                                        cancel_date_status: 1,
                                      },
                                      {
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                        },
                                      }
                                    );
                                  }
                                }));
                            } catch (err) {
                              console.error(err);
                            }
                          };
                          let alldayfromDateCancel = await getDateCancel(
                            leave_data_id
                          );
                          await editDateCancel(alldayfromDateCancel);
                          await deleteDateCancelBeforeApprove(
                            alldayfromDateCancel
                          );
                          ///////// ต้อง edit status 2 ของ date_cancel ให้เป็น 1
                        };
                        await FinalApprove();
                      }
                      await sendApproveDataStatus(
                        leave_approve_id,
                        leave_data_id,
                        "1"
                      );
                      const editLastApprove = async (id, item) => {
                        try {
                          const res = await axios.put(
                            baseURL + `/api/leave/${id}`,
                            {
                              leave_type_id: item?.leave_type_id, //ประเภทใบลา
                              form_type: item?.form_type, //ประเภทฟอร์มการลา
                              form_name: item?.form_name, //ชื่อฟอร์มการลา
                              budget_year: item?.budget_year, //ปีงบประมาณ
                              leave_name: item?.leave_name, //ชื่อเรื่องการลา
                              send_to: item?.send_to, //เรียน
                              leave_from_date: ConvertDate(
                                item?.leave_from_date
                              )?.toDateISO(), //ตั้งแต่วันที่
                              leave_from_timetype:
                                item?.leave_from_timetype, //ช่วงเวลา
                              leave_to_date: ConvertDate(
                                item?.leave_to_date
                              )?.toDateISO(), //ถึงวันที่
                              leave_to_timetype: item?.leave_to_timetype, //ช่วงเวลา
                              leave_days: item?.change_days, //กำหนดหรือจำนวนวัน
                              note: item?.note || "", //หมายเหตุ
                              user_id: item?.user_id, //ไอดีผู้ส่งฟอร์ม
                              leave_status: item?.leave_status,
                              approve_status: item?.approve_status,
                              approve_user_id: item?.approve_user_id,
                              approve_user: item?.approve_user,
                            },
                            {
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                            }
                          );
                        } catch (err) {
                          console.error(err);
                        }
                      };
                      let leaveDatabyId = await OpenDataByLeaveId(
                        leave_data_id,
                        true
                      );

                      let newLeaveName = leaveDatabyId?.leave_name?.split(" ")[0] + sufWord;
                      leaveDatabyId.leave_name = newLeaveName;
                      if (haveCancelDateStatus2) {
                        leaveDatabyId.leave_status = "C"
                      }
                      leaveDatabyId.leave_name = newLeaveName;
                      await editLastApprove(leave_data_id, leaveDatabyId);
                      await loadingApproveTable();
                      await getApproveDataTable(1);
                      await handleOpenSubmitSuccess();
                      setIsSending(false)
                    }}
                  >
                    {isFullButton && "อนุมัติยกเลิก "}
                    <i className="fa-solid fa-check"></i>
                  </button>
                </Tooltip>
                <Tooltip title="ไม่อนุมัติยกเลิก">
                  <button
                    className={`ms-1 btn btn-danger ${isFullButton && "w-50"}`}
                    disabled={(isSending)}
                    onClick={() => {
                      if (clickFromTable) {
                        OpenDataByLeaveId(leave_data_id, true);
                      }
                      if (closeModal) {
                        setModalEditApprove(false);
                      }
                      setModalNotApprove((prev) => ({
                        ...prev,
                        modal: true,
                        name: "ไม่อนุมัติยกเลิก",
                        leaveApproveId: leave_approve_id,
                        leaveApproveStatus: "0",
                        leaveDataId: leave_data_id,
                        leaveDataStatus: "5",
                        itemUpdate: item,
                      }));
                    }}
                  >
                    {isFullButton && "ไม่อนุมัติยกเลิก "}
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title="อนุมัติ">
                  <button
                    className={`ms-1 btn btn-success ${isFullButton && "w-50"}`}
                    disabled={(isSending)}
                    onClick={async () => {
                      // await sendLeaveDataStatus(item, "5");
                      setIsSending(true)
                      if (closeModal) {
                        setModalEditApprove(false);
                      }
                      await sendApproveDataStatus(
                        leave_approve_id,
                        leave_data_id,
                        "1"
                      );
                      await loadingApproveTable();
                      await getApproveDataTable(1);
                      await handleOpenSubmitSuccess();
                      setIsSending(false)
                    }}
                  >
                    {isFullButton && "อนุมัติ "}
                    <i className="fa-solid fa-check"></i>
                  </button>
                </Tooltip>
                <Tooltip title="ไม่อนุมัติ">
                  <button
                    className={`ms-1 btn btn-danger ${isFullButton && "w-50"}`}
                    disabled={(isSending)}
                    onClick={() => {
                      if (closeModal) {
                        setModalEditApprove(false);
                      }
                      setModalNotApprove((prev) => ({
                        ...prev,
                        modal: true,
                        name: "ไม่อนุมัติ",
                        leaveApproveId: leave_approve_id,
                        leaveApproveStatus: "0",
                        leaveDataId: leave_data_id,
                        leaveDataStatus: "6",
                        itemUpdate: item,
                      }));
                    }}
                  >
                    {isFullButton && "ไม่อนุมัติ "}
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </Tooltip>
              </>
            )}
          </>
        );
      }
    };

    const component = dropDownJSX(isFinal, leave_approve_id, leave_data_id, itemApprove, clickFromTable)
    const result = { component, isFinal, nextIsFinal, sendToApprove }
    // console.log(clickFromTable, result);

    return result;
  };

  const loadingApproveTable = async () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const sendApproveDataStatus = async (
    leave_approve_id,
    leave_data_id,
    approve_status,
    reason
  ) => {
    try {
      const res = await axios.post(
        baseURL + `/api/leave/approve`,
        {
          leave_approve_id: leave_approve_id,
          leave_data_id: leave_data_id,
          approve_status: approve_status,
          reason: reason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  const sendLeaveDataStatus = async (item, leaveStatus, approveStatus) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${item.leave_data_id}`,
        {
          leave_type_id: item.leave_type_id,
          form_type: item.form_type,
          form_name: item.form_name,
          budget_year: item.budget_year,
          leave_name: item.leave_name,
          send_to: item.send_to,
          leave_from_date: ConvertDate(
            new Date(item.leave_from_date)
          ).toDateISO(),
          leave_from_timetype: item.leave_from_timetype,
          leave_to_date: ConvertDate(new Date(item.leave_to_date)).toDateISO(),
          leave_to_timetype: item.leave_to_timetype,
          leave_days: item.leave_days,
          user_id: item.user_id,
          leave_status: leaveStatus,
          approve_status: approveStatus,
          approve_user_id: item.approve_id || item.approve_user_id,
          approve_user: item.approve_name || item.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };
  const handleOpenSubmitSuccess = async () => {
    setSubmitSuccess(true);
    // getApproveDataTable(1);

    setTimeout(() => {
      setSubmitSuccess(false);
    }, 1900);
  };
  const handleCloseSubmitSuccess = () => {
    setSubmitSuccess(false);
  };

  ////////// ดึงข้อมูลโดยใช้ leave_approve_id
  const OpenDataApprove = async (item) => {
    setModalEditApprove(true);
    // try {
    //   const res = await axios.get(baseURL + `/api/leave/data-approve/${id}`, {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   setLeaveDataEditApprove(res?.data?.result);
    // } catch (err) {
    //   console.error(err);
    // }
    setLeaveDataEditApprove(item);
  };

  /////////// ดึงข้อมูลโดยใช้ leave_data_id
  const OpenDataByLeaveId = async (id, clickFromTable = false) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[leave_data_id][0]": id || undefined,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveDataEdit(res?.data?.result[0]);
      let leave_user_id = res?.data?.result[0]?.user_id

      if (clickFromTable) {
        return res?.data?.result[0];
      }

      const getSeq = async (leave_user_id) => {
        await FetchAxiosGet(`/api/approvalSequence/${leave_user_id}`, token).then(async response => {
          let seq = response?.result
          let index = seq.findIndex(x => x?.user_id == user_id)
          let next = checkFinalApprove(leaveDataEdit?.form_type, seq[index]?.position_id) ? (seq[index]) : (seq[index - 1])
          setLeaveDataEdit((prev) => ({
            ...prev,
            send_to: `${next?.users_position_name}${next?.cont_to_main}`,
          }))
        }).catch(error => console.error("Error:", error))
      }
      await (res?.data?.result[0]?.send_to === "ผู้อำนวยการสำนักงานเลขาธิการ" && getSeq(leave_user_id))
    } catch (err) {
      console.error(err);
    }
  };

  const CloseDataApprove = () => {
    setModalEditApprove(false);
    setLeaveDataEditApprove("");
  };

  const handleCloseModalNoApprove = () => {
    setModalNotApprove((prev) => ({
      ...prev,
      modal: false,
      name: "",
      itemUpdate: {},
      leaveApproveId: null,
      leaveApproveStatus: null,
      leaveDataId: null,
      leaveDataStatus: null,
      reason: "",
    }));
  };

  //////////////////// ดู Flow การ approve ของใบลา
  const getFlowApproveUserbyId = async (id) => {
    try {
      const url = baseURL + "/api/leave/approve/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "created_date",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setGetUserApprove(res?.data?.result);
      setGetFlowApprove(res?.data?.position_users_approve);
    } catch (err) {
      console.error(err);
    }
  };

  const getPositionOfApproved = async (id) => {
    try {
      const url = baseURL + "/api/users/position/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 100,
        "order[0]": "position_id",
        "order[1]": "DESC",
        "filter[user_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setCheckPosition(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getFirstBudgetYear = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1,
        "order[0]": "budget_year",
        "order[1]": "ASC",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      if (res?.data?.result[0]?.budget_year) {
        let firstYear = Number(res?.data?.result[0]?.budget_year);
        let lastYear = Number(CheckBudgetYear());
        let arrYear = [];
        for (let i = firstYear; i <= lastYear; i++) {
          arrYear.push(i);
        }
        arrYear?.sort((a, b) => b - a);
        return setBudgetYearSelectList(arrYear);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const getSearchLeaveData = async (leave_type_id,leave_from_date,leave_to_date,leave_status,budget_year) => {
  //   try {
  //     const url = baseURL + `/api/leave/datatable`;
  //     const params = new URLSearchParams({
  //       page: 1,
  //       size: isFromIndex ? 5 : 10,
  //       "order[0]": "created_date",
  //       "order[1]": "DESC",
  //       "filter[user_id][0]": user_id,
  //       "filter[leave_type_id][0]": leave_type_id || "",
  //       "filter[leave_from_date][0]" : leave_from_date || "",
  //       "filter[leave_to_date][0]" : leave_to_date || "",
  //       "filter[leave_status][0]" : leave_status || "",
  //       "filter[budget_year][0]": budget_year || CheckBudgetYear(),

  //     });
  //     const config = {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       params,
  //     };
  //     const res = await axios.get(url, config);
  //     setLeaveData(res?.data?.result);
  //     setLeavePagination((prev) => ({
  //       ...prev,
  //       currentPage: res?.data?.info?.currentPage,
  //       totalPage: res?.data?.info?.totalPage,
  //       totalRows: res?.data?.info?.totalRows,
  //     }));
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const setFromDateSearch = (e) => {
    setSearchData((prev) => ({
      ...prev,
      fromDate: e,
      toDate: e,
    }));
  }

  const setToDateSearch = (e) => {
    setSearchData((prev) => ({
      ...prev,
      toDate: e,
    }));
  }

  const options = [
    { value: '4', label: 'รออนุญาต' },
    { value: '2', label: 'รออนุมัติ' },
    { value: '3', label: 'อนุญาต' },
    { value: '5', label: 'อนุมัติ' },
    { value: '0', label: 'อนุมัติ(มีการแก้ไข)' },
    { value: '9', label: 'ส่งกลับเพื่อแก้ไข' },
    { value: '7', label: 'ขออนุญาตยกเลิก' },
    { value: 'B', label: 'อนุญาตยกเลิก' },
    { value: 'A', label: 'อนุมัติยกเลิก' }
  ];

  const approveStatusBadge = (isFinal, forHistory) => {
    if (forHistory) {
      return leaveStatusBadge(forHistory)
    } else {
      return (<Badge pill color="primary" >{isFinal ? "รออนุมัติ" : "รออนุญาต"}</Badge>)
    }
  }

  // useEffect(() => {
  //   isFromIndex && setSearchData({
  //     docApproveType: "",
  //     leave_type_id: "",
  //     fromDate: "",
  //     toDate: "",
  //     status : "",
  //     budgetYear : null,
  //   });
  // }, [])

  return (
    <React.Fragment>
      <ModalApproveData
        userInfo={userInfo}
        modalEditApprove={modalEditApprove}
        leaveDataEdit={leaveDataEdit}
        setLeaveDataEdit={setLeaveDataEdit}
        leaveDataEditApprove={leaveDataEditApprove}
        CloseDataApprove={CloseDataApprove}
        getUserApprove={getUserApprove}
        checkLeaveTypeIdAndPosition={checkLeaveTypeIdAndPosition}
        user_position={user_position}
        checkPosition={checkPosition}
        showApproveButton={showApproveButton}
      />
      <ModalNotApprove
        leaveDataEdit={leaveDataEdit}
        modalNotApprove={modalNotApprove}
        handleCloseModalNoApprove={handleCloseModalNoApprove}
        setModalNotApprove={setModalNotApprove}
        sendApproveDataStatus={sendApproveDataStatus}
        sendLeaveDataStatus={sendLeaveDataStatus}
        handleOpenSubmitSuccess={handleOpenSubmitSuccess}
        getApproveDataTable={getApproveDataTable}
        loadingApproveTable={loadingApproveTable}
      />
      <ModalConfirmApprove
        submitSuccess={submitSuccess}
        handleOpenSubmitSuccess={handleOpenSubmitSuccess}
        handleCloseSubmitSuccess={handleCloseSubmitSuccess}
      />
      <Card style={{ minHeight: isFromIndex ? "450px" : "82vh" }}>
        <CardBody>
          {/* <Button onClick={() => {
            handleClick()
          }}>change layout</Button> */}
          {/* <returnDatePicker /> */}
          {!isFromIndex && (
            <>
              <Row className="mb-4">
                <Col xxl={8} xs={7}>
                  <h4>ประวัติการอนุมัติ</h4>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                  <Form>
                    <Row>
                      <Col xxl={2}>
                        <Row>
                          <Label className="text-end" xxl={4}>
                            เอกสาร
                          </Label>
                          <Col>
                            <Input
                              type="select"
                              placeholder="กรุณาระบุ"
                              value={searchData?.status}
                              onChange={async (e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  status: e.target.value,
                                }));
                              }}
                            >
                              <option value={0}>รอการอนุมัติ</option>
                              <option value={1}>อนุมัติแล้ว</option>
                              <option value={2}>ไม่อนุมัติ</option>
                            </Input>
                          </Col>
                        </Row>
                      </Col>
                      <Col xxl={3}>
                        <Row>
                          <Label className="text-end" xxl={2}>
                            เรื่อง
                          </Label>
                          <Col>
                            <Input
                              type="select"
                              placeholder="กรุณาระบุ"
                              value={searchData?.leave_type_id}
                              onChange={async (e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  leave_type_id: e.target.value,
                                }));
                                // await getSearchLeaveData(e.target.value,searchData?.fromDate,searchData?.toDate,searchData?.status,searchData?.budget_year)
                              }}
                            >
                              <option value="">ทั้งหมด</option>
                              {typeLeaveName?.map((item, idx, arr) => {
                                return (
                                  <React.Fragment key={idx}>
                                    {item?.leave_type?.map((item2) => {
                                      if (idx !== arr.length - 1) {
                                        return (
                                          <option
                                            key={item2?.leave_type_id}
                                            value={item2?.leave_type_id}
                                          >
                                            {item2?.leave_name}
                                          </option>
                                        );
                                      }
                                    })}
                                  </React.Fragment>
                                );
                              })}
                            </Input>
                          </Col>
                        </Row>
                      </Col>

                      <Col xxl={2}>
                        <Row>
                          <Label className="text-end" xxl={4}>
                            ลาวันที่
                          </Label>
                          <Col>
                            {/* <Flatpickr
                              className="form-control d-block"
                              placeholder="วัน/เดือน/ปี"
                              options={{
                                dateFormat: "d-m-Y",
                                ariaDateFormat: "F j, Y",
                                locale: "th",
                              }}
                              value={searchData?.fromDate}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  fromDate: e[0],
                                }));
                                if (searchData?.toDate !== 0) return 0;
                                // return getLeaveDataTable(
                                // 1,
                                // selectRow,
                                // "created_date",
                                // "DESC",
                                // searchData?.title,
                                // ConvertDate(e[0])?.toOnlyDate(),
                                // ConvertDate(searchData?.toDate)?.toOnlyDate()
                                // );
                              }}
                            /> */}
                            <NewThaiDatePicker name={"search_data_from_date"} value={searchData?.fromDate} setValue={setFromDateSearch} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
                          </Col>
                        </Row>
                      </Col>

                      <Col xxl={2}>
                        <Row>
                          <Label className="text-end" xxl={4}>
                            ถึงวันที่
                          </Label>
                          <Col>
                            {/* <Flatpickr
                              className="form-control d-block"
                              placeholder="วัน/เดือน/ปี"
                              options={{
                                dateFormat: "d-m-Y",
                                ariaDateFormat: "F j, Y",
                                locale: "th",
                              }}
                              value={searchData?.toDate}
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  toDate: e[0],
                                }));
                                if (searchData?.fromDate !== "") return 0;
                                // return getLeaveDataTable(
                                // 1,
                                // selectRow,
                                // "created_date",
                                // "DESC",
                                // searchData?.title,
                                // ConvertDate(searchData?.fromDate)?.toOnlyDate(),
                                // ConvertDate(e[0])?.toOnlyDate()
                                // );
                              }}
                            /> */}
                            <NewThaiDatePicker name={"search_data_to_date"} value={searchData?.toDate} minDate={searchData?.fromDate} setValue={setToDateSearch} returnType={"DateTime"} placeholderText="วัน/เดือน/ปี" />
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Button
                          color="success"
                          className="mx-2 w-25"
                          onClick={() => {
                            // getLeaveDataTable();
                            setApprovePagination((prev) => ({
                              ...prev,
                              currentPage: 1,
                            }));
                            if (searchData?.status === "0") {
                              getApproveDataTable(1, 0, 0)
                            } else if (searchData?.status === "1") {
                              getApproveDataTable(1, 1, null)
                            } else if (searchData?.status === "2") {
                              getApproveDataTable(1, 0, 1)
                            } else {
                              getApproveDataTable()
                            }
                            // setSearchData((prev) => ({
                            //   ...prev,
                            //   title: "",
                            //   fromDate: "",
                            //   toDate: "",
                            // }));
                            // setSortCount((prev) => ({
                            //   ...prev,
                            //   id: 0,
                            //   typeId: 0,
                            //   fromDate: 0,
                            //   toDate: 0,
                            // }));
                          }}
                        >
                          <i className="fa-sharp fa-solid fa-magnifying-glass pe-1"></i>ค้นหา
                        </Button>
                        <Button
                          color="warning"
                          className="w-50"
                          onClick={() => {
                            // getLeaveDataTable(currentPage);
                            setSearchData((prev) => ({
                              ...prev,
                              title: "",
                              fromDate: "",
                              toDate: "",
                              status: "",
                            }));
                            setSortCount((prev) => ({
                              ...prev,
                              id: 0,
                              typeId: 0,
                              fromDate: 0,
                              toDate: 0,
                            }));
                          }}
                        >
                          <i className="fas fa-xmark me-2"></i>ล้างการค้นหา
                        </Button>
                      </Col>
                      {/* <Col xxl={2}>
                        <Row>
                          <Label className="text-end" xxl={4}>
                            สถานะ
                          </Label>
                          <Col>
                            <Input
                              type="select"
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  status: e.target.value,
                                }));
                              }}
                            >
                              {options.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          <Label className="text-end" xxl={6}>
                            ปีงบประมาณ
                          </Label>
                          <Col>
                            <Input
                              value={searchData?.budget_year}
                              type="select"
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  budgetYear: Number(e.target.value),
                                }));
                              }}
                            >
                              {budgetYearSelectList?.length > 0 &&
                                budgetYearSelectList?.map((item, idx) => {
                                  return (
                                    <option key={idx} value={item}>
                                      {item}
                                    </option>
                                  );
                                })}
                            </Input>
                          </Col>
                        </Row>
                      </Col>
                      <Col xxl={1}>
                      </Col> */}
                    </Row>
                    <div className="mt-3">
                      <SelectOrg sizeXl={3} setDivisionOrg={setDivisionOrg} setGroupOrg={setGroupOrg} setUserOrg={setUserOrg} arrayOrgGroup={setArrayOrgGroup} checkAdmin={false} />
                    </div>
                  </Form>
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col>
              {isloading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "300px",
                  }}
                >
                  <LoadingData />
                </div>
              ) : (
                <FadeIn>
                  {dataApprove?.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                      }}
                    >
                      <h3>ไม่มีรายการลาที่ต้องอนุมัติ</h3>
                    </div>
                  ) : (
                    <div
                      style={{
                        overflowX: "scroll",
                        minHeight: "340px",
                      }}
                    >
                      <Table
                        striped
                        hover
                        style={{
                          tableLayout: "auto",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead className="table-primary fs-5 fw-bold">
                          <tr>
                            <th className="text-center" width="5%">
                              ลำดับ
                            </th>
                            <th className="text-center">เลขที่ใบลา</th>
                            <th>เรื่อง</th>
                            <th>ชื่อ</th>
                            <th className="text-center">ตั้งแต่วันที่</th>
                            <th className="text-center">ถึงวันที่</th>
                            <th className="text-center">รวม</th>
                            <th className="text-center">สถานะ</th>
                            {(showApproveButton || isFromIndex) && (<th></th>)}
                          </tr>
                        </thead>
                        <tbody className="table-light">
                          {chunkDataApprove &&
                            chunkDataApprove[
                              approvePagination?.currentPage - 1
                            ]?.map((item, idx) => {
                              return (
                                <tr
                                  key={item?.leave_approve_id}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td className="text-center">
                                    {idx +
                                      (approvePagination?.currentPage - 1) *
                                      selectRow +
                                      1}
                                  </td>
                                  <td
                                    className="text-center"
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                  >
                                    {item?.leave_data_id}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                  >
                                    {item?.leave_name}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                  >
                                    {item?.employee_name}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                    className="text-center"
                                  >
                                    {ConvertDate(
                                      item?.leave_from_date
                                    ).toThaiDateDMY()}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                    className="text-center"
                                  >
                                    {ConvertDate(
                                      item?.leave_to_date
                                    ).toThaiDateDMY()}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                    className="text-center"
                                  >
                                    {item?.leave_days}
                                  </td>
                                  <td
                                    onClick={() => {
                                      // setModalEditApprove(true);
                                      // OpenDataApprove(item);
                                      OpenDataApprove(item);
                                      getFlowApproveUserbyId(
                                        item?.leave_data_id
                                      );
                                      OpenDataByLeaveId(item?.leave_data_id);
                                      getPositionOfApproved(item?.user_id);
                                    }}
                                    className="text-center"
                                  >
                                    <h5 className="my-auto">
                                      {approveStatusBadge(checkFinalApprove(item?.form_type, user_position), isFromIndex ? null : item)}
                                    </h5>
                                  </td>
                                  {(showApproveButton || isFromIndex) && (<td>
                                    <Tooltip title="ตรวจสอบ">
                                      <button
                                        className="btn btn-info"
                                        onClick={() => {
                                          OpenDataApprove(
                                            item
                                          );
                                          getFlowApproveUserbyId(
                                            item?.leave_data_id
                                          );
                                          OpenDataByLeaveId(
                                            item?.leave_data_id
                                          );
                                          getPositionOfApproved(item?.user_id);
                                        }}
                                      >
                                        <i className="fa-solid fa-eye"></i>
                                      </button>
                                    </Tooltip>
                                    {(item?.leave_status !== null) && (item?.leave_status !== "7" && item?.leave_status !== "B") &&
                                      <Tooltip title="ส่งกลับแก้ไข">
                                        <button
                                          className="ms-1 btn btn-warning"
                                          onClick={() => {
                                            setModalNotApprove((prev) => ({
                                              ...prev,
                                              modal: true,
                                              name: "ส่งกลับแก้ไข",
                                              leaveApproveId:
                                                item?.leave_approve_id,
                                              leaveApproveStatus: "2",
                                              leaveDataId: item?.leave_data_id,
                                              leaveDataStatus: "9",
                                              itemUpdate: item,
                                            }));
                                          }}
                                        >
                                          <i className="fa-solid fa-reply"></i>
                                        </button>
                                      </Tooltip>
                                    }
                                    {
                                      checkLeaveTypeIdAndPosition(
                                        user_id === userInfo?.psac_user_approve?.approve_user_id ? 7 : user_position,
                                        item?.leave_approve_id,
                                        item?.leave_data_id,
                                        item?.leave_status,
                                        item,
                                        leaveDataEdit,
                                        false,
                                        false,
                                        true,
                                      ).component
                                    }
                                  </td>)}

                                </tr>
                              );
                            })}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </FadeIn>
              )}
            </Col>
          </Row>
        </CardBody>
        {dataApprove?.length === 0 ? null : (
          <Row className="mx-2" style={{ display: "flex", alignItems: "end" }}>
            <Col xxl={4} className="mb-2">
              <h4>
                <Badge className="badge-soft-primary me-1">
                  ทั้งหมด {approvePagination?.totalRows} รายการ
                </Badge>
              </h4>
            </Col>
            <Col xxl={8} className="d-flex justify-content-end">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={approvePagination?.currentPage === 1}>
                  <PaginationLink
                    onClick={() => {
                      setApprovePagination((prev) => ({
                        ...prev,
                        currentPage: 1,
                      }));
                    }}
                  >
                    หน้าแรก
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={approvePagination?.currentPage === 1}>
                  <PaginationLink
                    onClick={() => {
                      setApprovePagination((prev) => ({
                        ...prev,
                        currentPage: prev?.currentPage - 1,
                      }));
                    }}
                  >
                    ย้อนกลับ
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                  <PaginationLink>
                    หน้า {approvePagination?.currentPage} จาก{" "}
                    {approvePagination?.totalPage}
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    approvePagination?.currentPage ===
                    approvePagination?.totalPage ||
                    approvePagination?.totalPage < 1
                  }
                >
                  <PaginationLink
                    onClick={() => {
                      setApprovePagination((prev) => ({
                        ...prev,
                        currentPage: prev?.currentPage + 1,
                      }));
                    }}
                  >
                    ถัดไป
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    approvePagination?.currentPage ===
                    approvePagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() => {
                      // setCurrentPageApprove(chunkDataApprove?.length)
                      setApprovePagination((prev) => ({
                        ...prev,
                        currentPage: chunkDataApprove?.length,
                      }));
                    }}
                  >
                    หน้าสุดท้าย
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </Card>
    </React.Fragment>
  );
};

// const mapStateToProps = state => ({
//   layoutModeType: state.Layout.layoutModeType
// });

// const mapDispatchToProps = {
//   changeLayoutMode,
// };

export default TableApprove;
// export default connect(mapStateToProps, mapDispatchToProps)(TableApprove);
